'use strict';

import PropTypes from 'prop-types';
import cx from 'classnames';
import React from 'react';

import RowEntry from './row.entry.component';
import RowSubtable from './row.subtable.component';

const BodyFoldableInverted = props => {
	const { component, expandedTables, report, tables, table } = props;

	/**
	 * Parses body from table content and layout object
	 */
	const parseBody = table.content.map((row, key) => {
		let uniqueRowKey = `${row.meta.data.unique_identifier}_Entry`;
		let uniqueTableKey = `${row.meta.data.unique_identifier}_Table`;

		return [
			expandedTables[uniqueTableKey] && (
				<RowSubtable
					key={uniqueTableKey}
					activeInteractionClassName={{
						'report-old__subtable--foldable-inverted--unfolded':
							expandedTables[uniqueTableKey]
					}}
					data={row}
					{...props}
				/>
			),
			<RowEntry
				key={uniqueRowKey}
				activeInteractionClassName={{
					'report-old__entry--foldable-inverted--unfolded':
						expandedTables[uniqueTableKey]
				}}
				context="body"
				tables={tables}
				data={row.total.data}
				meta={row}
				interaction={component.handleTableToggleExpand.bind(
					this,
					report.name,
					uniqueTableKey,
					expandedTables[uniqueTableKey]
				)}
				component={component}
				modifierClassNames={cx({ 'report-old__entry--odd': key % 2 === 0 })}
			/>
		];
	});

	return <tbody>{parseBody}</tbody>;
};

BodyFoldableInverted.propTypes = {
	expandedTables: PropTypes.object.isRequired,
	report: PropTypes.object.isRequired,
	tables: PropTypes.object.isRequired,
	table: PropTypes.object.isRequired
};

export default BodyFoldableInverted;
